import { useChildComponentRouteV2 } from '@gogame/screens';

import ParentCampaignDetails from './ParentCampaignDetails';

export const ParentCampaignDetailsRouteElement = ({ onChange }) => {
  return useChildComponentRouteV2(ParentCampaignDetails, { onChange });
};
